/*
 * @Author: huangzeshen
 * @Date: 2023-07-04 15:55:01
 * @LastEditors: huangzeshen
 * @LastEditTime: 2023-09-28 14:52:50
 * @FilePath: /open-web/src/locals/zh-CN/stock.js
 * @Description: 
 */
export default {

  // 通用名称
  'stock.common.Pre-market': '盘前',
  'stock.common.After-market': '盘后',
  'stock.common.cur.hk': '港币',
  'stock.common.cur.us': '美元',
  'stock.common.cur.cn': '元',
  'stock.common.cur.shares': '股',

  // 通知
  'stock.notion.btn': '已了解',

  // 自选
  'stock.index.header.title': '自选',
  'stock.index.tabs.1': '全部',
  'stock.index.tabs.2': '美股',
  'stock.index.tabs.3': '港股',
  'stock.index.tabs.4': 'A股',
  'stock.index.add': '添加股票',
  'stock.index.table.edit': '编辑',
  'stock.index.table.price': '最新价',
  'stock.index.table.changePercent': '涨跌幅',

  // 编辑自选
  'stock.edit.header.title': '编辑自选',
  'stock.edit.header.save': '保存',
  'stock.edit.header.all': '全选',
  'stock.edit.header.delete': '删除',
  'stock.edit.table.header.1': '股票代码',
  'stock.edit.table.header.2': '置顶',
  'stock.edit.table.header.3': '上移',
  'stock.edit.table.header.4': '下移',
  'stock.edit.success': '编辑成功',

  // 股票详情
  'stock.details.list.title': '行情数据',
  'stock.details.list.1': '开盘',
  'stock.details.list.2': '昨收',
  'stock.details.list.3': '最高',
  'stock.details.list.4': '最低',
  'stock.details.list.5': '成交量',
  'stock.details.list.6': '成交额',
  'stock.details.list.7': '市值',
  'stock.details.list.8': '换手率',
  'stock.details.list.9': '总股本',
  'stock.details.list.10': '市盈率(静)',
  'stock.details.list.11': '每手',
  'stock.details.list.12': '币种',
  'stock.details.list.13': '振幅',
  'stock.details.list.14': '平均价',
  'stock.details.list.15': '52周最高',
  'stock.details.list.16': '52周最低',
  'stock.details.list.17': '上涨',
  'stock.details.list.18': '平盘',
  'stock.details.list.19': '下跌',
  'stock.details.list.20': '总发行量',
  'stock.details.list.21': '单位净值',
  'stock.details.list.22': '资产规模',
  'stock.details.list.23': '溢价率',
  'stock.details.list.24': '行权价',
  'stock.details.list.25': '打和点',
  'stock.details.list.26': '街货量',
  'stock.details.list.27': '街货比',
  'stock.details.list.28': '换股价',
  'stock.details.list.29': '换股比例',
  'stock.details.list.30': '回收价',
  'stock.details.list.31': '杠杆比率',
  'stock.details.list.32': '最后交易',
  'stock.details.list.33': '到期日',
  'stock.details.list.34': '对冲值',
  'stock.details.list.35': '溢价',
  'stock.details.list.36': '资产类别',
  'stock.details.list.37': '交易币种',

  // 搜索
  'stock.search.hedaer.tips': '搜索',
  'stock.search.hedaer.History': '搜索历史',
  'stock.search.hedaer.etf': '股票&ETFs',


  // 快捷交易
  'stock.trade.header.title': '交易',
  'stock.trade.btn.text.1': '买入',
  'stock.trade.btn.text.2': '卖出',
  'stock.trade.btn.text.3': '限价单',
  'stock.trade.btn.text.4': '价格',
  'stock.trade.btn.text.5': '数量',
  'stock.trade.btn.text.6': '请输入数量',
  'stock.trade.btn.text.7': '订单金额',
  'stock.trade.btn.text.8': '盘前盘后交易',
  'stock.trade.btn.text.9': '允许',
  'stock.trade.btn.text.10': '不允许',
  'stock.trade.btn.text.11': '总现金可用',
  'stock.trade.btn.text.12': '现金可买',
  'stock.trade.btn.text.13': '最多可买(融资)',
  'stock.trade.btn.text.14': '最高 ',
  'stock.trade.btn.text.15': ' 倍杠杆',
  'stock.trade.btn.text.16': '市价',
  'stock.trade.btn.text.17': '竞价单',
  'stock.trade.btn.text.18': '请输入价格',


  'internal_khshz': '开户审核中',
  'open_account_status_2': '未开户',
  'auction_buy': '集合竞价买入',
  'auction_sell': '集合竞价卖出',
  'pre_market_buy': '盘前买入',
  'pre_market_sell': '盘前卖出',
  'after_market_buy': '盘后买入',
  'after_market_sell': '盘后卖出',
  'buy': '买入',
  'sell': '卖出',
  'add_to_follow_success': '添加自选成功',
  'delete_from_follow_success': '移除自选成功',
  'pre_market': '盘前',
  'after_market': '盘后',
  'internal_lz': '轮证',
  "not_open": '未开盘',
  "pre_market_bidding": '盘前竞价',
  "wait_opening": '等待开盘',
  "trading": '交易中',
  "lunchtime_break": '午间休市',
  "closing_bid": '收盘竞价',
  "closed": '已收盘',
  "in_recess": '休市中',
  "after_hours_dealing": '盘后交易',
  "premarket_trading": '盘前交易',
  "stock_market_sh_csc": '沪港通',
  "stock_market_sz_csc": '深港通',
  "all_position": '全仓',
  "half_position": '1/2仓',
  "one_third_of_position": '1/3仓',
  "one_fourth_of_position": '1/4仓',
  "internal_gpdm": '代码',
  "stock": '股票',
  "type": '类型',
  "direction": '方向',
  "use_rz_buy": '将使用融资买入',
  "cancel": '取消',
  "internal_qr": '确认',
  'error_amount_value_1': '只能是每手',
  'error_amount_value_2': '股的整数倍，自动校正',
  'trade_order_confirm': '订单确认',
  'success_text': '成功',
  'currency_type': '货币',
  'asset_product': '商品',
  'asset_futures': '期货',
  'asset_fixed_rate_product': '定息产品',
  'asset_multi_asset': '多元资产',
  'hold': '持仓',
  'trade_freeze': '冻结',
  'trade_can_sell': '可卖',
  'place_order_success_tip': '已提交，等待成交',


}
